import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "mb-6" }
const _hoisted_2 = { class: "flex items-start gap-4 mb-3" }
const _hoisted_3 = { class: "flex-1 min-w-0 pt-1" }
const _hoisted_4 = { class: "text-2xl sm:text-3xl font-bold text-gray-900 dark:text-white leading-tight" }
const _hoisted_5 = ["disabled"]
const _hoisted_6 = {
  key: 0,
  class: "w-4 h-4",
  fill: "none",
  stroke: "currentColor",
  viewBox: "0 0 24 24"
}
const _hoisted_7 = {
  key: 1,
  class: "w-4 h-4 animate-spin",
  fill: "none",
  viewBox: "0 0 24 24"
}
const _hoisted_8 = { class: "flex flex-wrap items-center gap-2 sm:gap-3 pl-0 sm:pl-[4.5rem]" }
const _hoisted_9 = { class: "inline-flex items-center gap-1.5 px-3 py-1.5 bg-blue-50 dark:bg-blue-900/20 text-blue-700 dark:text-blue-300 rounded-lg text-sm font-medium" }
const _hoisted_10 = { class: "inline-flex items-center gap-1.5 px-3 py-1.5 bg-green-50 dark:bg-green-900/20 text-green-700 dark:text-green-300 rounded-lg text-sm font-medium" }
const _hoisted_11 = {
  key: 0,
  class: "inline-flex items-center gap-1.5 px-3 py-1.5 bg-gradient-to-r from-purple-500 to-pink-500 text-white rounded-lg text-sm font-medium shadow-sm"
}
const _hoisted_12 = {
  key: 1,
  class: "inline-flex items-center gap-1.5 px-3 py-1.5 bg-gradient-to-r from-orange-500 to-red-500 text-white rounded-lg text-sm font-medium shadow-sm"
}

interface Props {
  title: string
  categoryName: string
  downloadCount: number
  isWallpaperPack: boolean
  isLiveWallpaper?: boolean
  showQuickDownload: boolean
  isDownloading: boolean
}


export default /*@__PURE__*/_defineComponent({
  __name: 'WallpaperHeader',
  props: {
    title: {},
    categoryName: {},
    downloadCount: {},
    isWallpaperPack: { type: Boolean },
    isLiveWallpaper: { type: Boolean },
    showQuickDownload: { type: Boolean },
    isDownloading: { type: Boolean }
  },
  emits: ["back", "quick-download"],
  setup(__props: any) {





return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("button", {
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('back'))),
        class: "flex items-center gap-2 px-4 py-2.5 rounded-xl bg-white dark:bg-gray-800 shadow-sm hover:shadow-md transition-all duration-200 hover:-translate-x-0.5 flex-shrink-0 mt-1"
      }, _cache[2] || (_cache[2] = [
        _createElementVNode("svg", {
          class: "w-4 h-4 text-gray-600 dark:text-gray-300",
          fill: "none",
          stroke: "currentColor",
          viewBox: "0 0 24 24"
        }, [
          _createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-width": "2",
            d: "M15 19l-7-7 7-7"
          })
        ], -1),
        _createElementVNode("span", { class: "text-sm font-medium text-gray-700 dark:text-gray-300" }, " Back ", -1)
      ])),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("h1", _hoisted_4, _toDisplayString(_ctx.title), 1)
      ]),
      (_ctx.showQuickDownload)
        ? (_openBlock(), _createElementBlock("button", {
            key: 0,
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('quick-download'))),
            disabled: _ctx.isDownloading,
            class: _normalizeClass(["hidden sm:flex items-center gap-2 px-5 py-2.5 bg-gradient-to-r from-purple-600 to-pink-600 hover:from-purple-700 hover:to-pink-700 text-white text-sm font-medium rounded-xl shadow-md hover:shadow-lg transition-all duration-200 disabled:opacity-50 flex-shrink-0", { 'animate-pulse': _ctx.isDownloading }])
          }, [
            (!_ctx.isDownloading)
              ? (_openBlock(), _createElementBlock("svg", _hoisted_6, _cache[3] || (_cache[3] = [
                  _createElementVNode("path", {
                    "stroke-linecap": "round",
                    "stroke-linejoin": "round",
                    "stroke-width": "2",
                    d: "M7 16a4 4 0 01-.88-7.903A5 5 0 1115.9 6L16 6a5 5 0 011 9.9M9 19l3 3m0 0l3-3m-3 3V10"
                  }, null, -1)
                ])))
              : (_openBlock(), _createElementBlock("svg", _hoisted_7, _cache[4] || (_cache[4] = [
                  _createElementVNode("circle", {
                    class: "opacity-25",
                    cx: "12",
                    cy: "12",
                    r: "10",
                    stroke: "currentColor",
                    "stroke-width": "4"
                  }, null, -1),
                  _createElementVNode("path", {
                    class: "opacity-75",
                    fill: "currentColor",
                    d: "M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                  }, null, -1)
                ]))),
            _createElementVNode("span", null, _toDisplayString(_ctx.isDownloading ? 'Downloading...' : 'Download'), 1)
          ], 10, _hoisted_5))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_8, [
      _createElementVNode("div", _hoisted_9, [
        _cache[5] || (_cache[5] = _createElementVNode("svg", {
          class: "w-4 h-4",
          fill: "none",
          stroke: "currentColor",
          viewBox: "0 0 24 24"
        }, [
          _createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-width": "2",
            d: "M7 7h.01M7 3h5c.512 0 1.024.195 1.414.586l7 7a2 2 0 010 2.828l-7 7a2 2 0 01-2.828 0l-7-7A1.994 1.994 0 013 12V7a4 4 0 014-4z"
          })
        ], -1)),
        _createElementVNode("span", null, _toDisplayString(_ctx.categoryName), 1)
      ]),
      _createElementVNode("div", _hoisted_10, [
        _cache[6] || (_cache[6] = _createElementVNode("svg", {
          class: "w-4 h-4",
          fill: "none",
          stroke: "currentColor",
          viewBox: "0 0 24 24"
        }, [
          _createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-width": "2",
            d: "M7 16a4 4 0 01-.88-7.903A5 5 0 1115.9 6L16 6a5 5 0 011 9.9M9 19l3 3m0 0l3-3m-3 3V10"
          })
        ], -1)),
        _createElementVNode("span", null, _toDisplayString(_ctx.downloadCount) + " downloads", 1)
      ]),
      (_ctx.isWallpaperPack)
        ? (_openBlock(), _createElementBlock("div", _hoisted_11, _cache[7] || (_cache[7] = [
            _createElementVNode("svg", {
              class: "w-4 h-4",
              fill: "currentColor",
              viewBox: "0 0 20 20"
            }, [
              _createElementVNode("path", {
                "fill-rule": "evenodd",
                d: "M3 4a1 1 0 011-1h4a1 1 0 010 2H6.414l2.293 2.293a1 1 0 01-1.414 1.414L5 6.414V8a1 1 0 01-2 0V4zm9 1a1 1 0 010-2h4a1 1 0 011 1v4a1 1 0 01-2 0V6.414l-2.293 2.293a1 1 0 11-1.414-1.414L13.586 5H12zm-9 7a1 1 0 012 0v1.586l2.293-2.293a1 1 0 111.414 1.414L6.414 15H8a1 1 0 010 2H4a1 1 0 01-1-1v-4zm13-1a1 1 0 011 1v4a1 1 0 01-1 1h-4a1 1 0 010-2h1.586l-2.293-2.293a1 1 0 111.414-1.414L15.586 13H14a1 1 0 01-1-1z",
                "clip-rule": "evenodd"
              })
            ], -1),
            _createElementVNode("span", null, "Wallpaper Pack", -1)
          ])))
        : _createCommentVNode("", true),
      (_ctx.isLiveWallpaper)
        ? (_openBlock(), _createElementBlock("div", _hoisted_12, _cache[8] || (_cache[8] = [
            _createElementVNode("svg", {
              class: "w-4 h-4",
              fill: "currentColor",
              viewBox: "0 0 20 20"
            }, [
              _createElementVNode("path", {
                "fill-rule": "evenodd",
                d: "M10 18a8 8 0 100-16 8 8 0 000 16zM9.555 7.168A1 1 0 008 8v4a1 1 0 001.555.832l3-2a1 1 0 000-1.664l-3-2z",
                "clip-rule": "evenodd"
              })
            ], -1),
            _createElementVNode("span", null, "Live Wallpaper", -1)
          ])))
        : _createCommentVNode("", true)
    ])
  ]))
}
}

})